(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doublecup-camo-drip-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function prepareCamo(root) {
    if (root.dataset.camoReady) return;
    root.dataset.camoReady = 'true';
    const select = root.querySelector('[data-camo-variant]');
    const submit = root.querySelector('[data-camo-submit]');
    if (!select || !submit) return;
    const price = root.querySelector('[data-camo-price]');
    const status = root.querySelector('[data-camo-status]');
    const label = submit.querySelector('[data-camo-submit-label]');
    const media = root.querySelector('[data-camo-product-media] img');
    const caption = root.querySelector('[data-camo-image-caption]');
    const thumbnails = [...root.querySelectorAll('[data-camo-thumbnail]')];
    const thumbnailRow = root.querySelector('[data-camo-thumbnails]');
    const initialThumbnail = thumbnails.find(button => button.getAttribute('aria-pressed') === 'true');
    const initialImage = media ? {src:media.getAttribute('src'),srcset:media.getAttribute('srcset'),alt:media.alt,width:media.getAttribute('width'),height:media.getAttribute('height'),imageId:initialThumbnail?.dataset.imageId} : null;
    function showPhoto(photo) {
      if (!media || !photo.src) return;
      media.src = photo.src;
      media.alt = photo.alt || '';
      if (photo.srcset) media.setAttribute('srcset',photo.srcset); else media.removeAttribute('srcset');
      if (photo.width) media.setAttribute('width',photo.width);
      if (photo.height) media.setAttribute('height',photo.height);
      if (caption) caption.textContent = media.alt;
      thumbnails.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.imageId === photo.imageId)));
    }
    function photoFromElement(element) {
      return {src:element.dataset.image,alt:element.dataset.imageAlt,width:element.dataset.imageWidth,height:element.dataset.imageHeight,imageId:element.dataset.imageId};
    }
    thumbnails.forEach(button => button.addEventListener('click',() => showPhoto(photoFromElement(button))));
    if (thumbnailRow && media) thumbnailRow.hidden = false;
    function syncVariant(updateAddress) {
      const selected = select.options[select.selectedIndex];
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      const ready = submit.dataset.termsReady === 'true';
      submit.disabled = !available || !ready;
      label.textContent = available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
      price.textContent = selected.dataset.price;
      status.textContent = available ? (ready ? submit.dataset.preorderLabel : '') : submit.dataset.unavailableLabel;
      if (updateAddress && media && initialImage) {
        showPhoto(selected.dataset.image ? photoFromElement(selected) : initialImage);
      }
      if (updateAddress && window.location.pathname.includes('/products/')) {
        const address = new URL(window.location.href);
        address.searchParams.set('variant',selected.value);
        window.history.replaceState({},'',address);
      }
    }
    select.addEventListener('change',() => syncVariant(true));
    syncVariant(false);
  }
  function mountCamo(scope) {
    if (scope.matches && scope.matches('[data-camo-launch]')) prepareCamo(scope);
    scope.querySelectorAll('[data-camo-launch]').forEach(prepareCamo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mountCamo(document)); else mountCamo(document);
  document.addEventListener('shopify:section:load',event => mountCamo(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doublecup-corner-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-review-rotation')) {
    customElements.define('dc-review-rotation', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hovered = false;
        this.inView = false;
        this.track = this.querySelector('.dc-corner-proof__slides');
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.counter = this.querySelector('[data-review-count]');
        this.querySelector('.dc-corner-proof__controls').hidden = false;
        this.querySelector('[data-review-prev]').addEventListener('click', () => this.manual(-1), options);
        this.querySelector('[data-review-next]').addEventListener('click', () => this.manual(1), options);
        this.pauseButton.addEventListener('pointerdown', () => { this.toggleTarget = !this.paused; }, options);
        this.pauseButton.addEventListener('click', () => { this.paused = this.toggleTarget ?? !this.paused; this.toggleTarget = undefined; this.schedule(); }, options);
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
        this.addEventListener('touchstart', (event) => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, { ...options, passive: true });
        this.addEventListener('touchend', (event) => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.manual(dx < 0 ? 1 : -1);
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.schedule(); }, { threshold: .3 });
        this.observer.observe(this);
        this.show(0);
        this.schedule();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      manual(direction) {
        this.paused = true;
        this.schedule();
        this.show(this.index + direction);
      }
      schedule() {
        clearTimeout(this.timer);
        this.pauseButton.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.track.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (this.paused || this.hovered || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, 7000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doublecup-product-clean"]) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.cleanReady) return;
    root.dataset.cleanReady = 'true';
    const form = root.querySelector('.dc-clean-form');
    const quantity = form.querySelector('[name="quantity"]');
    const minus = root.querySelector('[data-clean-minus]');
    const plus = root.querySelector('[data-clean-plus]');
    const syncQuantity = () => {
      const value = Math.min(50, Math.max(1, Math.trunc(Number(quantity.value) || 1)));
      quantity.value = value;
      minus.disabled = value <= 1;
      plus.disabled = value >= 50;
    };
    minus.addEventListener('click', () => { quantity.value = Number(quantity.value) - 1; syncQuantity(); });
    plus.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; syncQuantity(); });
    quantity.addEventListener('change', syncQuantity);
    const mediaButtons = root.querySelectorAll('[data-clean-media]');
    const mediaPanels = root.querySelectorAll('[data-clean-media-panel]');
    mediaButtons.forEach((button) => button.addEventListener('click', () => {
      mediaPanels.forEach((panel) => {
        const active = panel.dataset.cleanMediaPanel === button.dataset.cleanMedia;
        if (!active && !panel.hidden) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
          panel.querySelectorAll('iframe').forEach((frame) => { frame.src = frame.src; });
        }
        panel.hidden = !active;
      });
      mediaButtons.forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail === button)));
    }));
    const data = JSON.parse(root.querySelector('[data-clean-variants]').textContent);
    const select = form.querySelector('select[name="id"]');
    if (select) select.addEventListener('change', () => {
      const variant = data.variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      root.querySelectorAll('[data-clean-price]').forEach((price) => { price.innerHTML = variant.price; });
      const compare = root.querySelector('[data-clean-compare]');
      compare.innerHTML = variant.compare || '';
      compare.hidden = !variant.compare;
      const available = variant.available;
      root.querySelectorAll('[data-clean-submit]').forEach((button) => { button.disabled = !available; button.textContent = available ? data.addLabel : data.soldOutLabel; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    });
    const primary = root.querySelector('[data-clean-primary]');
    const sticky = root.querySelector('[data-clean-sticky]');
    let scheduled = false;
    const mobileLayout = window.matchMedia('(max-width:749px)');
    const navigation = document.getElementById('site-navigation');
    const updateSticky = () => {
      const bounds = primary.getBoundingClientRect();
      if (mobileLayout.matches) {
        const navigationBottom = Math.max(0, navigation ? navigation.getBoundingClientRect().bottom : 0);
        sticky.hidden = bounds.top >= navigationBottom && bounds.bottom <= window.innerHeight - 120;
      } else {
        sticky.hidden = bounds.bottom > 0;
      }
      scheduled = false;
    };
    window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); } }, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    new IntersectionObserver(updateSticky).observe(primary);
    updateSticky();
  };
  document.querySelectorAll('[data-clean-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-clean-product]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
